export default class ItemVisitor {
  visitItem(item) {}
}
